import { Injectable, inject } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UrlUtils } from '../shared/utils/url.utils';
import { ConfigurationHandlerService } from './configuration-handler.service';

@Injectable({ providedIn: 'root' })
export class ApcGuard  {
    private router = inject(Router);
    private configurationService = inject(ConfigurationHandlerService);


    institutionCode:string;

    constructor(){
        this.institutionCode = UrlUtils.getParam('institution');
    }
    canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        // return true;
        const isApcEnabled = this.configurationService.isCustomerParameterEnabled('esploro_oable_integration');
        if (!isApcEnabled) {
            const queryParams = {institution: this.institutionCode};
            this.router.navigate(['/'], { queryParams: queryParams});
        }
        return isApcEnabled;
    }

}
